import { fetchWrapper } from '@/utils/helpers/fetch-wrapper';

export interface UploadConfig {
  max_upload_size_mb: number;
  allowed_extensions: string[];
}

const baseUrl = `${import.meta.env.VITE_API_URL_API}/storage/upload-config`;

export const uploadConfigService = {
  async fetch(): Promise<UploadConfig> {
    return fetchWrapper.get(baseUrl);
  },
};
